var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"show":_vm.isShow,"z-index":99999,"custom-style":{
		background: 'rgb(0, 0, 0, 0.6)',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	}}},[_c('van-loading',{attrs:{"type":"spinner","size":"32px","color":"#fff"}},[_c('span',{staticStyle:{"color":"#fff","font-size":"16px"}},[_vm._v(_vm._s(_vm.title || '加载中···'))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }